import { z } from "zod";

export const INTRO_REQUEST_TYPE = "intro" as const;

const INTRO_REQUEST_STATUS_VALUES = {
  PENDING: "pending",

  SENT: "sent",

  SEEN: "seen",

  ACCEPTED: "accepted",

  DECLINED: "declined",

  CANCELLED: "cancelled",
} as const;

export const IntroRequestStatusSchema = z.enum(INTRO_REQUEST_STATUS_VALUES);

export type IntroRequestStatus = z.infer<typeof IntroRequestStatusSchema>;

const INTRO_REQUEST_RESPONDED_STATES: readonly IntroRequestStatus[] = [
  INTRO_REQUEST_STATUS_VALUES.ACCEPTED,
  INTRO_REQUEST_STATUS_VALUES.DECLINED,
  INTRO_REQUEST_STATUS_VALUES.CANCELLED,
];

const INTRO_REQUEST_ACTIVE_STATES: readonly IntroRequestStatus[] = [
  INTRO_REQUEST_STATUS_VALUES.PENDING,
  INTRO_REQUEST_STATUS_VALUES.SENT,
  INTRO_REQUEST_STATUS_VALUES.SEEN,
];

export const IntroRequestStatus = {
  ...INTRO_REQUEST_STATUS_VALUES,

  RESPONDED_STATES: INTRO_REQUEST_RESPONDED_STATES,

  ACTIVE_STATES: INTRO_REQUEST_ACTIVE_STATES,
} as const;

const S = IntroRequestStatus;
export const INTRO_REQUEST_TRANSITIONS_DATA = [
  { from: S.PENDING, to: S.SENT },
  { from: S.PENDING, to: S.CANCELLED },
  { from: S.SENT, to: S.SEEN },
  { from: S.SENT, to: S.CANCELLED },
  { from: S.SEEN, to: S.CANCELLED },

  { from: S.SEEN, to: S.ACCEPTED },
  { from: S.SEEN, to: S.DECLINED },

  { from: S.PENDING, to: S.ACCEPTED },
  { from: S.SENT, to: S.ACCEPTED },

  // Someone who declined an intro and then requests it themselves is mutual
  // interest: their own request re-opens the one they turned down.
  { from: S.DECLINED, to: S.ACCEPTED },
] as const;
